<template>
    <div class="cookie">
        <div class="wrapper">
            <div class="cookie__content">
                <div class="cookie__title">
                    <p>Мы иcпользуем cookie файлы!</p>
                    <p>Просматривая этот сайт, вы соглашаетесь с нашей <a target="_blank" :href="modulePolicy.file_src">политикой конфиденциальности</a></p>
                </div>
                <div class="cookie__btn btn btn--middle">Принять</div>
                <div class="cookie__close"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name    : "CookiePopup",
    computed: {
        ... mapState([
            'modulePolicy'
        ]),
    },
}
</script>

<style scoped>

</style>